<div class="make-responsive-entitiesFooter">
  <div class="d-flex align-items-end">
    <div class="d-flex align-items-basline"
      *ngIf="tenantCategory !== 'monotainer' && tenantGenericConfig?.tenant !== 'TRL' && tenantGenericConfig?.tenant !== 'VOT'">
      <div class="mr-2 d-flex" *ngFor="let footerIconContent of footerIconList;">
        <img
          src="{{ footerIconContent?.imgUrl ? (footerIconContent?.imgUrl + token) : '../../../../assets/images/no-icon-trl.svg' }}"
          class="w-20 m" [alt]="footerIconContent?.alert"
          title="{{ footerIconContent?.alert + ':' + footerIconContent?.attributeValue}}"
          [ngClass]="{'dmk-img-fit': tenantGenericConfig?.tenant === 'DMK'}">
      </div>
    </div>
    <div *ngIf="tenantGenericConfig?.tenant === 'TRL'" class="d-flex">
      <img src="../../../../assets/images/ignition-trl.svg" alt="ignition" matTooltip="Ignition" class="h-32">
      <img src="../../../../assets/images/acceleration-trl.svg" alt="acc" matTooltip="Hard Acceleration" class="h-32">
      <img src="../../../../assets/images/clutch-trl.svg" alt="clutch" matTooltip="Clutch Press" class="h-32">
      <img src="../../../../assets/images/brake-press-trl.svg" alt="brake" matTooltip="Brake Press" class="h-32">
    </div>
    <div *ngIf="tenantGenericConfig?.tenant === 'VOT'" class="d-flex align-items-basline w-100 gap10">
      <div class="validops-footer uni-profile-footer">
        <div class="validops-value uni-profile-value" [title]="((+content?.aggrDetails?.totalDistance) || 0).toFixed(3)">
          {{content?.aggrDetails?.totalDistance ? content?.aggrDetails?.trimmedTotalDistance : 0}} Km</div>
        <div class="validops-value-footer uni-profile-value-footer d-flex">
          <div><img src="../../../../assets/images/distancevalidops.svg" alt="Distance"></div>
          <div matTooltip="Distance">Distance</div>
        </div>
      </div>
      <div class="validops-footer uni-profile-footer">
        <div class="validops-value uni-profile-value" [title]="((+content?.aggrDetails?.totalEnginehours) || 0).toFixed(3)">
          {{content?.aggrDetails?.totalEnginehours ? content?.aggrDetails?.totalEnginehoursTrimmed : 0}} hrs</div>
        <div class="validops-value-footer uni-profile-value-footer d-flex">
          <div><img src="../../../../assets/images/enginehrs.svg" alt="Engine" ></div>
          <div class="time-label-ellipsis" matTooltip="Operating Hours">{{'Operating Hours'}}</div>
        </div>
      </div>
    </div>
  </div>
  <mat-card-header class="w-100 d-grid p-0">
    <mat-card-title class="w-100" >
      <div class="d-grid form-gap w-100">
        <div class="d-flex align-items-center position-relative place-end gap10">
          <div *ngIf="tenantGenericConfig?.tenant === 'VOT'" (click)="onDtcClick($event, content?.activeDtcCasesCount);">
            <img src="../../../../assets/images/dtc_icon_mgm.svg" [matTooltip]="'Active DTC Cases:' + (content?.activeDtcCasesCount ?? 0)" class="h-24 cursor" *ngIf="content?.activeDtcCasesCount" 
              alt="DTC" />
              <img src="../../../../assets/images/dtc-icon-disabled.svg" [matTooltip]="'Active DTC Cases:' + (content?.activeDtcCasesCount ?? 0)" class="h-24 bell-pointer" *ngIf="!content?.activeDtcCasesCount" 
              alt="DTC" />
          </div>
          <div (click)="onAlertClick($event, alertCount);"> 
            <img
              [src]="alertCount ? '../../../../assets/images/alert_icon_mgm.svg' : '../../../../assets/images/alert-icon-disabled.svg'"
              [matTooltip]="'Active Alerts:' + alertCount" class="h-24" alt="Alerts"
              [ngClass]="{'bell-pointer': !alertCount}" />
            <sup class="sup-bg1" *ngIf="alertCount">
              <strong class="ft-12 text-danger">{{ alertCount }}</strong>
            </sup>
          </div>
        </div>
      </div>
    </mat-card-title>
  </mat-card-header>
</div>